import { render } from "./SecondaryNav.vue?vue&type=template&id=2e4af740&scoped=true"
import script from "./SecondaryNav.vue?vue&type=script&lang=js"
export * from "./SecondaryNav.vue?vue&type=script&lang=js"

import "./SecondaryNav.vue?vue&type=style&index=0&id=2e4af740&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4af740"]])

export default __exports__